import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid, parseOptions} from '../question-helper';

@Component({
    selector: 'app-question-select-button',
    templateUrl: './question-select-button.component.html',
    styleUrls: ['./question-select-button.component.scss'],
    standalone: false
})
export class QuestionSelectButtonComponent implements OnInit {

  @Input() question: Question;
  @Input() readonly = false;
  @Input() showLabel = false;
  @Output() questionAnswer = new EventEmitter<any>();

  items: any[] = [];
  uniqueControlName = `select-button-${newGuid()}`;

  constructor() { }

  ngOnInit(): void {
    if (this.question) {
      this.items = parseOptions(this.question.options);
      if (this.items?.length) {
        this.items = this.items.sort((a, b) => a.answer_order > b.answer_order ? 1 : a.answer_order < b.answer_order ? -1 : 0);
      }
    }
  }

  onRadioCheck(answer: any): void {
    if (this.question) {
      this.question.answer = answer;
      this.questionAnswer.emit(this.question);
    }
  }

}
